import React from "react";
import moment from "moment";
import { Table } from "antd";
import AnchorTableCell from "../shared/AnchorTableCell/AnchorTableCell";
import BacklinkUrlTableCell from "./BacklinkUrlTableCell";

const { Column } = Table;

const BacklinksTable = ({ dataSource }) => {
  return (
    <Table dataSource={dataSource} pagination={false} size="small" data-cy="backlinks-table">
      <Column className="al-left va-top" title="#" dataIndex="key" align="left" />

      <Column
        title="Backlink URL"
        dataIndex="source_url"
        render={(_, record) => <BacklinkUrlTableCell {...record} />}
      />
      <Column className="no-wrap al-left" title="Page Score" dataIndex="page_score" />

      <Column
        className="no-wrap"
        title="Target URL"
        dataIndex="target_url"
        render={(_, record) => <AnchorTableCell url={record["target_url"]} anchor={record["target_url"]} />}
      />
      <Column
        className="no-wrap"
        title="Link Type"
        dataIndex="nofollow"
        render={(_, record) => (record["nofollow"] === "true" ? "Nofollow" : "Follow")}
      />

      <Column
        className="no-wrap al-left"
        title="External Links"
        dataIndex="external_num"
        render={(_, record) => parseInt(record["external_num"]).toLocaleString()}
      />

      <Column
        className="no-wrap al-left"
        title="Internal Links"
        dataIndex="internal_num"
        render={(_, record) => parseInt(record["internal_num"]).toLocaleString()}
      />

      <Column
        className="no-wrap al-right"
        title="First Seen"
        dataIndex="first_seen"
        render={(_, record) => moment.unix(record["first_seen"]).format("MMM DD, YYYY")}
      />
      <Column
        className="no-wrap al-right"
        title="Last Seen"
        dataIndex="last_seen"
        render={(_, record) => moment.unix(record["last_seen"]).format("MMM DD, YYYY")}
      />
    </Table>
  );
};

export default BacklinksTable;
